import Units from "../../../utils/Units";
import Time from "../axes/Time";
import Celsius from "../axes/Celsius";

let AsparagusDay1 = {
    type: "line",
    label: "Temperature Average 1",
    fill: false,
    lineTension: 0,
    colorPalette: 0,
    borderWidth:2,

    pointStyle: "circle",
    pointRadius:0,
    pointHoverRadius: 2,
    pointBorderWidth:.5,
    z:50,

    tooltipLabelValueCallback: (value) => {
        return Units.rounded(value,2);
    },

    yAxis:Celsius,
    xAxis:Time
};

export default AsparagusDay1;



// WEBPACK FOOTER //
// ./src/components/chart/channels/AsparagusDay1.js